import classNames from "classnames";
import { ChangeEventHandler } from "react";

import { TableContextType, useTableContext } from "../context";
import { GRID_CELL_FOCUS_CLASSES } from "../grid-classes";
import Select from "../select";
import TableColumnHeaderWrapper from "./cell-wrapper";

interface TableHeadingProps {
  selectable: boolean;
}

function TableHeading({ selectable }: TableHeadingProps) {
  const { table, t, selectionIntent } = useTableContext() as TableContextType;
  const headerGroups = table.getHeaderGroups();
  const allRowsChecked = table.getIsAllRowsSelected();
  const someRowsChecked = table.getIsSomeRowsSelected();
  const toggleAllRowsSelected = table.getToggleAllRowsSelectedHandler();
  const onAllRowsCheckedChange: ChangeEventHandler<HTMLInputElement> = (
    event,
  ) => {
    if (selectionIntent) selectionIntent.current = "all";
    toggleAllRowsSelected(event);
  };

  return (
    <thead className="bg-tint">
      {headerGroups.map((headerGroup) => (
        <tr key={headerGroup.id}>
          {selectable && (
            <th
              scope="col"
              className={classNames(
                "h-target overflow-hidden py-2 px-[13px] w-target",
                GRID_CELL_FOCUS_CLASSES,
              )}
            >
              <Select
                label={t("selectAllRows")}
                checked={allRowsChecked}
                indeterminate={someRowsChecked && !allRowsChecked}
                onChange={onAllRowsCheckedChange}
              />
            </th>
          )}
          {headerGroup.headers
            .filter((header) => header.column.getIsVisible())
            .map((header) => (
              <TableColumnHeaderWrapper key={header.id} header={header} />
            ))}
        </tr>
      ))}
    </thead>
  );
}

export default TableHeading;
